import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PartnerService } from './core/services/partner.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class App {
  constructor(protected readonly partnerService: PartnerService) {}
}
